import removeNamespace from "../namespace-helper"
// import axios from "../../plugins/axios";

export const Types = {
  mutations: {
    LOADING_YES: "loading/UPDATE_YES",
    LOADING_NO: "loading/UPDATE_NO",
  },
}

const _types = removeNamespace("loading/", Types)
const state = {
  loadingIsVisible: false,
  loadingMessage: "",
}

// mutations
const mutations = {
  [_types.mutations.LOADING_YES]: (state, message) => {
    state.loadingIsVisible = true
    if (message === undefined) {
      state.loadingMessage = ""
    } else {
      state.loadingMessage = message
    }
  },
  [_types.mutations.LOADING_NO]: state => {
    state.loadingIsVisible = false
    state.loadingMessage = ""
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}
